import script from "./ow-clients-form.vue?vue&type=script&setup=true&lang=js"
export * from "./ow-clients-form.vue?vue&type=script&setup=true&lang=js"

import "./ow-clients-form.vue?vue&type=style&index=0&id=4d53c0c0&lang=scss"
import "./ow-clients-form.vue?vue&type=style&index=1&id=4d53c0c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d53c0c0"]])

export default __exports__